import React, { useEffect } from 'react'
import config from '../config'
import Amplitude from '../utils/amplitudeHelper'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import routes from 'src/routes'
import { useWindowSize } from 'src/utils/useWindowSize'
import { useAutoMute } from 'src/utils/useAutoMute'
import back from '../images/lobbyEntry/back-icon.png'

const StyledPage = styled.div`
  height: ${(props) => props.windowHeight}px;
  .back-to-lobby {
    position: fixed;
    top: 2%;
    right: 2%;
    color: #43464B;
    min-width: 70px;
    text-align: center;
    small {
      margin: 0 auto;
      display: block;
      font-weight: 700;
      font-size: 70%;
    }
    img {
      width: 8vw;
      min-width: 80px;
      max-width: 100px;
    }
  }
`

export const VirtualTourPage = ({ currentUser }) => {
  useAutoMute()
  const { windowWidth, windowHeight } = useWindowSize()

  useEffect(() => {
    document.title = `${config.eventName} | Virtual Tour`
  }, [])

  useEffect(() => {
    Amplitude.visit('Virtual Tour')
  }, [currentUser.id])

  return (
    <StyledPage windowHeight={windowHeight}>
      <iframe
        style={{ height: '100%', width: '100%', overflow: 'hidden', border: 'none' }}
        allowFullScreen={false}
        title="Virtual Tour"
        scrolling="no"
        src='https://mpoc.org.my/vr-oil-palm/plantation-tour.html'
      ></iframe>
      
      <Link to={routes.lobby} className="back-to-lobby" >
        <img src={back} alt="back to lobby" />
      </Link>
    </StyledPage>
  )
}